import { render } from "./ChallengeSettings.vue?vue&type=template&id=09afa682&scoped=true"
import script from "./ChallengeSettings.vue?vue&type=script&lang=js"
export * from "./ChallengeSettings.vue?vue&type=script&lang=js"

import "./ChallengeSettings.vue?vue&type=style&index=0&id=09afa682&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09afa682"]])

export default __exports__